export const polnovesStore = [
  { name: 'Полновесные', value: 'Полновес' },
  { name: 'Облегченные', value: 'Облегченная' },
];
